import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateEventMutation } from "../../redux/services/eventService/event.Services";

function AddEvents() {
    const navigate = useNavigate();
    const [createEvent, { isLoading }] = useCreateEventMutation();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        start_date: "",
        end_date: "",
        venue: "",
        capacity: "",
        status: "upcoming",
        image: null
    });
    const [previewImage, setPreviewImage] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({
                ...formData,
                image: file
            });
            // Create preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.title.trim()) {
            errorToast("Event title is required");
            return;
        }
        if (!formData.start_date) {
            errorToast("Start date is required");
            return;
        }
        if (!formData.end_date) {
            errorToast("End date is required");
            return;
        }

        try {
            // Create FormData for file upload
            const formDataToSend = new FormData();
            formDataToSend.append('title', formData.title);
            formDataToSend.append('description', formData.description);
            formDataToSend.append('start_date', formData.start_date);
            formDataToSend.append('end_date', formData.end_date);
            formDataToSend.append('venue', formData.venue);
            formDataToSend.append('capacity', formData.capacity);
            formDataToSend.append('status', formData.status);
            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            const response = await createEvent(formDataToSend).unwrap();
            successToast(response?.message || "Event Created Successfully");
            navigate("/events");
        } catch (error) {
            console.log(error);
            errorToast(error?.data?.message || "Failed To Create Event");
        }
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            Add Event
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                Add Event
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate("/events")}
                    >
                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>
                        Event List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row">
                                {/* Title */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>
                                            Event Title <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            placeholder='Enter Event Title'
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                </div>

                                {/* Venue */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Venue</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            placeholder='Enter Venue'
                                            name="venue"
                                            value={formData.venue}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="col-md-12 mt-3">
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            className='form-control'
                                            placeholder='Enter Event Description'
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            rows="3"
                                        />
                                    </div>
                                </div>

                                {/* Start Date */}
                                <div className="col-md-3 mt-3">
                                    <div className="form-group">
                                        <label>
                                            Start Date <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className='form-control'
                                            name="start_date"
                                            value={formData.start_date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* End Date */}
                                <div className="col-md-3 mt-3">
                                    <div className="form-group">
                                        <label>
                                            End Date <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className='form-control'
                                            name="end_date"
                                            value={formData.end_date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Capacity */}
                                <div className="col-md-2 mt-3">
                                    <div className="form-group">
                                        <label>Capacity</label>
                                        <input
                                            type="number"
                                            className='form-control'
                                            placeholder='Capacity'
                                            name="capacity"
                                            value={formData.capacity}
                                            onChange={handleChange}
                                            min="0"
                                        />
                                    </div>
                                </div>

                                {/* Status */}
                                <div className="col-md-2 mt-3">
                                    <div className="form-group">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="upcoming">Upcoming</option>
                                            <option value="ongoing">Ongoing</option>
                                            <option value="completed">Completed</option>
                                            <option value="cancelled">Cancelled</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Image Upload */}
                                <div className="col-md-2 mt-3">
                                    <div className="form-group">
                                        <label>Event Image</label>
                                        <input
                                            type="file"
                                            className='form-control'
                                            name="image"
                                            onChange={handleFileChange}
                                            accept="image/*"
                                        />
                                    </div>
                                </div>

                                {/* Image Preview */}
                                {previewImage && (
                                    <div className="col-md-12 mt-3">
                                        <div className="form-group">
                                            <label>Image Preview</label>
                                            <div>
                                                <img 
                                                    src={previewImage} 
                                                    alt="Event Preview" 
                                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'cover' }}
                                                    className="img-thumbnail"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Submit Button */}
                                <div className="col-md-12 mt-4">
                                    <div className="form-group">
                                        <button
                                            type="submit"
                                            className='btn btn-primary'
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Creating...
                                                </>
                                            ) : (
                                                "Create Event"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddEvents;